export const CONTR_PARTIES_LIST = 'CONTR_PARTIES_LIST';
export const ADD_PARTY_SUCCESS = 'ADD_PARTY_SUCCESS';
export const EDIT_PARTY_SUCCESS = 'EDIT_PARTY_SUCCESS';
export const PARTY_CRUD = 'PARTY_CRUD';
export const TOGGLE_VIEW_EDIT = 'TOGGLE_VIEW_EDIT';
export const PARTIES_LOADER = 'PARTIES_LOADER';
